import React, { memo } from 'react';

import RoutesWrapper from '@components/common/RoutesWrapper';

import { useAdminPanelRoutes } from '@hooks/utils/useAdminPanelRoutes';

import { sideBarTitle } from './constants';

const AdminPanel = () => {
	const {
		routesList,
		firstNotHiddenItem,
		sideBarItems,
		isLoading,
	} = useAdminPanelRoutes();

	return (
		<RoutesWrapper
			basePathPrefix='/admin-panel'
			firstNotHiddenItem={firstNotHiddenItem}
			isLoading={isLoading}
			routesList={routesList}
			sideBarItems={sideBarItems}
			sideBarTitle={sideBarTitle}
		/>
	);
};

export default memo(AdminPanel);
